import { Controller } from "@hotwired/stimulus"

// A "select all" checkbox driving a list of child checkboxes, and kept in step
// when children are toggled individually (indeterminate while mixed).
export default class extends Controller {
  static targets = ["parent", "child"]

  toggleAll() {
    const checked = this.parentTarget.checked
    this.childTargets.forEach((child) => {
      child.checked = checked
    })
    this.parentTarget.indeterminate = false
  }

  syncParent() {
    if (!this.hasParentTarget) return
    const checkedCount = this.childTargets.filter((child) => child.checked).length
    this.parentTarget.checked = checkedCount === this.childTargets.length && checkedCount > 0
    this.parentTarget.indeterminate = checkedCount > 0 && checkedCount < this.childTargets.length
  }
}
